module.exports = __webpack_public_path__ + "img/1 (84).a9f7c1fa.png";